import { Attendance, AttendanceEmployee, saveAttendance } from "@/api/openapi";
import { AttendancesContext, PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { attendanceToTempAttendance } from "../../attendanceUtils";

export function useAttendanceTable() {
  const { lang, selectedMandate } = useContext(PspContext);
  const {
    selectedMonth,
    selectedYear,
    attendanceMonth,
    setAttendanceMonth,
    setTempAttendanceMonth,
  } = useContext(AttendancesContext);

  const [expandedEmployee, setExpandedEmployee] =
    useState<AttendanceEmployee | null>(null);
  const [noteOpenEmployee, setNoteOpenEmployee] =
    useState<AttendanceEmployee | null>(null);
  const [noteDialogOpen, setNoteDialogOpen] = useState(false);
  const [note, setNote] = useState("");

  function onCloseNote() {
    setNoteDialogOpen(false);
    setTimeout(() => {
      setNoteOpenEmployee(null);
      setNote("");
    }, 250);
  }

  function onOpenNote(employee: AttendanceEmployee) {
    if (!attendanceMonth) {
      toast(translate("somethingWentWrong", lang));
      return;
    }
    setNoteDialogOpen(true);
    setNoteOpenEmployee(employee);
    setNote(
      attendanceMonth.attendances.find(
        (a) => a.employee.matricola === employee.matricola,
      )?.note ?? "",
    );
  }

  function onSaveNote() {
    if (!attendanceMonth) {
      toast(translate("somethingWentWrong", lang));
      return;
    }
    if (!selectedMandate) {
      toast(translate("noMandateSelected", lang));
      return;
    }
    if (selectedMonth === undefined || selectedYear === undefined) {
      return;
    }

    const newNoteAttendance: Attendance[] = attendanceMonth.attendances.map(
      (a) =>
        noteOpenEmployee?.matricola === a.employee.matricola
          ? {
              ...a,
              note,
            }
          : a,
    );
    saveAttendance({
      body: {
        data: newNoteAttendance,
        mandateId: selectedMandate.id,
        month: selectedMonth,
        year: selectedYear,
      },
      query: {
        draft: false,
      },
    }).then(({ data, error }) => {
      if (error) {
        toast(translate("somethingWentWrong", lang));
        return;
      }
      setAttendanceMonth(data);
      setTempAttendanceMonth(attendanceToTempAttendance(data));
      toast(translate("noteSavedSuccessfully", lang));
      onCloseNote();
    });
  }

  const expandedEmployeeIndex = expandedEmployee
    ? (attendanceMonth?.attendances.findIndex(
        (a) =>
          a.employee.filiale === expandedEmployee.filiale &&
          a.employee.matricola === expandedEmployee.matricola,
      ) ?? null)
    : null;

  return {
    lang,
    setExpandedEmployee,
    setNoteOpenEmployee,
    noteOpenEmployee,
    note,
    setNote,
    onSaveNote,
    onCloseNote,
    noteDialogOpen,
    onOpenNote,
    selectedMonth,
    selectedYear,
    expandedEmployeeIndex,
  };
}
